import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const SellerAuthContext = createContext(null);

export const SellerAuthProvider = ({ children }) => {
  const [seller, setSeller] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const res = await axios.get('/api/seller/auth/me', {
        withCredentials: true,
      });

      const data = res.data || {};

      if (data.ok && data.is_seller === true) {
        setSeller({
          is_seller: true,
          seller_id: data.seller_id ?? null,
          seller_username: data.seller_username ?? '',
          shop_id: data.shop_id ?? null,
          shop_name: data.shop_name ?? '',
          redirect: data.redirect || '/seller',
        });
      } else {
        setSeller(null);
      }
    } catch (err) {
      setSeller(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (username, password) => {
    try {
      const res = await axios.post(
        '/api/seller/login_process',
        { username, password },
        { withCredentials: true }
      );

      const data = res.data || {};

      if (data.ok) {
        await fetchMe();
      }

      return data;
    } catch (err) {
      const data = err.response?.data || {
        ok: false,
        error: '로그인 중 오류가 발생했습니다.',
      };
      return data;
    }
  };

  const logout = async () => {
    try {
      const res = await axios({
        url: '/api/seller/logout',
        method: 'POST',
        withCredentials: true,
      });

      const data = res.data || {};

      setSeller(null);

      return data;
    } catch (err) {
      setSeller(null);
      return err.response?.data || {
        ok: false,
        error: '로그아웃 중 오류가 발생했습니다.',
      };
    }
  };

  const value = {
    seller,
    isSeller: !!seller?.is_seller,
    loading,
    login,
    logout,
    refreshSellerAuth: fetchMe,
  };

  return (
    <SellerAuthContext.Provider value={value}>
      {children}
    </SellerAuthContext.Provider>
  );
};

export const useSellerAuth = () => {
  const context = useContext(SellerAuthContext);

  if (!context) {
    throw new Error('useSellerAuth must be used within a SellerAuthProvider');
  }

  return context;
};

export default SellerAuthContext;